import { DomrfCalculator, IProgram, IProps as IDomrfCalculatorProps } from '@cian/frontend-domrf-calculator';
import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { useMortgageMiniCalculatorMicrofrontend } from 'shared/hooks/useMortgageMiniCalculatorMicrofrontend';
import { offerSelector } from 'shared/selectors';
import { selectMortgageMiniCalculatorSuburbanEnabled } from 'shared/selectors/featureToggle';
import { getDealType, isSale } from 'shared/utils/deal_type';

import { useApplicationContext } from '../ApplicationContext';
import { MortgageCalculatorContainer } from '../MortgageCalculator';

type TTextData = Pick<
  IDomrfCalculatorProps,
  'title' | 'subtitle' | 'priceTooltipTitle' | 'priceTooltipText' | 'escrowTooltipText' | 'escrowTooltipTitle'
>;

export const SuburbanCalculatorContainer = () => {
  const { config } = useApplicationContext();
  const offer = useSelector(offerSelector);
  const dealType = getDealType(offer);
  const regionId = offer.geo.address[0].id;
  const isMortgageCalculatorInSuburbanCard = useSelector(selectMortgageMiniCalculatorSuburbanEnabled);

  const domrfPrograms = config.get<IProgram[]>('audience.domrfMortgage.programs');
  const textData = config.get<TTextData>('audience.domrfMortgage.textData') || undefined;

  const { isAvailable: isAvailableMiniCalculatorInSuburbanCard, manifest } = useMortgageMiniCalculatorMicrofrontend(
    isMortgageCalculatorInSuburbanCard,
  );

  if (domrfPrograms && offer.category === 'landSale') {
    return (
      <CardSectionNew>
        <DomrfCalculator
          programs={domrfPrograms}
          regionId={regionId}
          startPrice={7000000}
          pageType="card"
          objectId={offer.id}
          {...textData}
        />
      </CardSectionNew>
    );
  }

  if (isAvailableMiniCalculatorInSuburbanCard && isSale(dealType)) {
    return (
      <CardSectionNew>
        <Microfrontend
          name={manifest.microfrontendName}
          image={manifest.imageVersion}
          runtime={manifest.runtimeName}
          instance={manifest.instanceId}
        />
      </CardSectionNew>
    );
  }

  return <MortgageCalculatorContainer />;
};
